import { Style } from "mapbox-gl";

//https://basemaps.linz.govt.nz/v1/styles/topolite.json?api=
export const getStyleJson = (baseMapsApiKey: string): Style => ({
  "version": 8,
  "id": "st_topolite",
  "name": "topolite",
  "sources": {
    "LINZ Basemaps": {
      "type": "vector",
      "attribution": "© 2022 Toitū Te Whenua - CC BY 4.0",
        "url": `https://basemaps.linz.govt.nz/v1/tiles/topographic/EPSG:3857/tile.json?api=${baseMapsApiKey}`
    },
    "LINZ-Texture-Relief": {
      "tiles": [
        `https://basemaps.linz.govt.nz/v1/tiles/texturereliefshade/EPSG:3857/{z}/{x}/{y}.webp?api=${baseMapsApiKey}`
      ],
      "type": "raster",
      "minzoom": 0,
      "maxzoom": 20,
      "tileSize": 256
    },
    "basemaps-elevation-terrain-rgb-dem": {
      "type": "raster-dem",
      "tiles": [
        `https://basemaps.linz.govt.nz/v1/tiles/elevation/WebMercatorQuad/{z}/{x}/{y}.png?api=${baseMapsApiKey}&pipeline=terrain-rgb`
      ],
      "tileSize": 256
    }
  },
  "layers": [
    {
      "id": "Background",
      "type": "background",
      "filter": ["==", ["get", "class"], "dock"],
      "layout": {},
      "paint": {"background-color": "hsl(203, 67%, 19%)"}
    },
    {
      "id": "Landcover-Sand",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "minzoom": 8,
      "filter": ["==", ["get", "class"], "sand"],
      "layout": {},
      "paint": {
        "fill-color": "hsla(39, 39%, 23%, 0.3)",
        "fill-outline-color": "hsl(39, 39%, 23%)"
      }
    },
    {
      "id": "Landuse-Mangrove",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 12,
      "filter": ["==", ["get", "wetland_feature"], "mangrove"],
      "layout": {},
      "paint": {
        "fill-color": "hsla(80, 27%, 27%, 0.3)",
        "fill-outline-color": "hsl(80, 27%, 27%)"
      }
    },
    {
      "id": "Coastline2",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "coastline",
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          1,
          "hsl(48, 10%, 18%)",
          10,
          "hsl(48, 46%, 6%)"
        ],
        "fill-outline-color": "hsl(48, 46%, 6%)"
      }
    },
    {
      "id": "Vegetation-Scatteredscrub",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": [
        "all",
        ["==", ["get", "class"], "grass"],
        ["==", ["get", "distribution"], "scattered"],
        ["==", ["get", "natural"], "scrub"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsla(100, 30%, 22%, 0.4)",
        "fill-antialias": false,
        "fill-outline-color": "hsla(100, 30%, 22%, 0.1)"
      }
    },
    {
      "id": "Vegetation-Scrub",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": [
        "all",
        ["!", ["has", "distribution"]],
        ["==", ["get", "class"], "grass"],
        ["==", ["get", "natural"], "scrub"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsla(98,31%,19%,0.4)",
        "fill-outline-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsla(98,31%,19%,0.1)",
          10,
          "hsla(98,31%,19%, 0.1)",
          19,
          "hsla(98,31%,19%, 0.1)"
        ]
      }
    },
    {
      "id": "Vegetation-Exotic",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": [
        "all",
        ["==", ["get", "landuse"], "wood"],
        ["==", ["get", "tree"], "exotic"]
      ],
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsla(103, 36%, 25%, 0.4)",
          11,
          "hsla(93, 43%, 20%, 0.4)"
        ],
        "fill-outline-color": "hsla(0, 3%, 19%, 0)"
      }
    },
    {
      "id": "Vegetation-Native",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": ["==", ["get", "tree"], "native"],
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsla(105, 28%, 23%, 0.4)",
          9,
          "hsla(103, 25%, 34%, 0.4)",
          11,
          "hsla(100, 28%, 33%, 0.4)",
          14,
          "hsla(98, 32%, 28%, 0.4)"
        ],
        "fill-outline-color": "hsla(0, 1%, 12%, 0)"
      }
    },
    {
      "id": "Landcover-Ice",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": ["==", ["get", "class"], "ice"],
      "layout": {},
      "paint": {
        "fill-color": "hsla(0, 0%, 0%, 0.44)",
        "fill-outline-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          "hsla(0, 0%, 0%, 0.01)",
          10,
          "hsla(180, 79%, 18%, 0.5)",
          11,
          "hsla(180, 46%, 61%, 0.5)"
        ]
      }
    },
    {
      "id": "Landcover-Orchard",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "minzoom": 10,
      "filter": ["==", ["get", "landuse"], "orchard"],
      "layout": {},
      "paint": {
        "fill-color": "rgba(27, 127, 36, 0.1)",
        "fill-translate-anchor": "viewport",
        "fill-outline-color": "hsl(0, 1%, 2%)"
      }
    },
    {
      "id": "Landcover-Vineyard",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "minzoom": 10,
      "filter": ["==", ["get", "landuse"], "vineyard"],
      "layout": {},
      "paint": {
        "fill-color": "rgba(31,73,35,0.2)",
        "fill-translate-anchor": "viewport",
        "fill-antialias": false
      }
    },
    {
      "id": "Landcover-Swamp-Fill",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": [
        "all",
        ["==", ["get", "class"], "wetland"],
        ["==", ["get", "wetland_type"], "swamp"]
      ],
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(176, 38%, 17%)",
          14,
          "hsl(189, 30%, 18%)"
        ],
        "fill-outline-color": "hsl(183, 30%, 28%)"
      }
    },
    {
      "id": "Poi-Mine-Quarry-Poly",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "minzoom": 12,
      "filter": [
        "any",
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "mine"],
          false
        ],
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "quarry"],
          false
        ]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(0, 0%, 22%)",
        "fill-opacity": 0.5,
        "fill-outline-color": "hsl(0,0%,40%)"
      }
    },
    {
      "id": "Landcover-Swamp-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "class"], "wetland"],
        ["==", ["get", "wetland_type"], "swamp"]
      ],
      "layout": {},
      "paint": {
        "line-width": 0.5,
        "line-dasharray": [6, 6, 4, 4],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          "hsla(199, 100%, 61%, 0.1)",
          11,
          "hsla(199, 98%, 64%, 0.8)"
        ]
      }
    },
    {
      "id": "Contours-All",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "contours",
      "minzoom": 9,
      "maxzoom": 16,
      "filter": [
        "all",
        ["!=", ["get", "type"], "index"],
        ["!", ["has", "designated"]],
        ["!", ["has", "nat_form"]]
      ],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          0.3,
          16,
          0.2
        ],
        "line-color": "hsla(41, 76%, 30%, 0.75)"
      }
    },
    {
      "id": "Contours-Designated",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "contours",
      "minzoom": 9,
      "maxzoom": 16,
      "filter": ["has", "designated"],
      "layout": {},
      "paint": {
        "line-width": 0.4,
        "line-color": "hsla(41, 77%, 32%, 0.75)",
        "line-dasharray": [30, 30]
      }
    },
    {
      "id": "Contours-Index",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "contours",
      "minzoom": 11,
      "maxzoom": 16,
      "filter": ["==", ["get", "type"], "index"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          15,
          1.2
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          "hsla(41, 78%, 28%, 0.5)",
          15,
          "hsla(41, 77%, 29%, 0.5)"
        ]
      }
    },
    {
      "id": "Contours-Natural",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "contours",
      "minzoom": 9,
      "maxzoom": 16,
      "filter": ["has", "nat_form"],
      "layout": {},
      "paint": {
        "line-width": 0.6,
        "line-color": "hsla(41, 77%, 27%, 0.5)",
        "line-dasharray": [30, 10, 10, 10]
      }
    },
    {
      "id": "Aeroway-Airport",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "aeroway",
      "minzoom": 10,
      "filter": ["==", ["get", "class"], "aerodrome"],
      "layout": {},
      "paint": {
        "fill-color": "hsla(0, 0%, 22%, 0.7)",
        "fill-outline-color": "hsl(0, 0%, 32%)"
      }
    },
    {
      "id": "Aeroway-Airstrip-Sealed",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "aeroway",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "runway"],
        ["==", ["get", "surface"], "sealed"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsla(0, 0%, 22%, 0.5)",
        "fill-antialias": false
      }
    },
    {
      "id": "Aeroway-Runway-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "aeroway",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "runway"],
        ["==", ["get", "surface"], "sealed"]
      ],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          2,
          1,
          10,
          0.7,
          19,
          0.5
        ],
        "line-color": "rgba(125, 125, 125, 1)"
      }
    },
    {
      "id": "Aeroway-Airstrip-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "aeroway",
      "minzoom": 13,
      "filter": [
        "all",
        ["!", ["has", "surface"]],
        ["==", ["get", "class"], "runway"]
      ],
      "layout": {},
      "paint": {"line-color": "hsl(0, 0%, 49%)", "line-dasharray": [5, 5]}
    },
    {
      "id": "Water-Polys-Outline",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 11,
      "filter": [
        "any",
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "canal"],
          false
        ],
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "lagoon"],
          false
        ],
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "lake"],
          false
        ],
        [
          "case",
          ["==", ["typeof", ["get", "class"]], "string"],
          ["==", ["get", "class"], "river"],
          false
        ]
      ],
      "layout": {"line-cap": "round", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          9,
          1,
          15,
          2.5
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(203, 71%, 29%)",
          13,
          "hsla(201, 60%, 45%, 0.3)",
          19,
          "hsl(201, 55%, 48%)"
        ]
      }
    },
    {
      "id": "Water-Canal-Poly-Named",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 9,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "canal"],
        ["has", "name"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(199, 69%, 21%)",
        "fill-outline-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(203, 69%, 63%)",
          13,
          "hsla(199, 97%, 37%, 0.3)",
          19,
          "hsl(199, 97%, 28%)"
        ]
      }
    },
    {
      "id": "Water-Lagoon",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "filter": ["==", ["get", "class"], "lagoon"],
      "paint": {
        "fill-color": "hsl(203, 69%, 29%)",
        "fill-outline-color": "hsl(203, 55%, 38%)"
      }
    },
    {
      "id": "Water-Lake",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "filter": ["==", ["get", "class"], "lake"],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 70%, 27%)",
        "fill-outline-color": "hsl(203, 55%, 37%)"
      }
    },
    {
      "id": "Water-Lake-Named",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "lake"],
        ["has", "name"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 69%, 32%)",
        "fill-outline-color": "hsl(203, 55%, 42%)"
      }
    },
    {
      "id": "Water-River-Poly-Named",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "river"],
        ["has", "name"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 68%, 30%)",
        "fill-outline-color": "hsl(203, 55%, 40%)"
      }
    },
    {
      "id": "Water-Canal-Poly",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 13,
      "maxzoom": 21,
      "filter": ["==", ["get", "class"], "canal"],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 68%, 27%)",
        "fill-outline-color": "hsl(203, 55%, 37%)"
      }
    },
    {
      "id": "Water-River-Poly",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 13,
      "maxzoom": 21,
      "filter": ["==", ["get", "class"], "river"],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 69%, 24%)",
        "fill-outline-color": "hsl(203, 55%, 34%)"
      }
    },
    {
      "id": "Water-Reef",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 10,
      "filter": ["==", ["get", "class"], "reef"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          2,
          0.5,
          10,
          1
        ],
        "line-color": "hsl(199, 99%, 67%)",
        "line-dasharray": [12, 2]
      }
    },
    {
      "id": "Waterway-Canal-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 13,
      "maxzoom": 21,
      "filter": ["==", ["get", "class"], "canal"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          1,
          13,
          0.75,
          18,
          0.5
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          11,
          "hsla(201, 58%, 32%, 0.75)",
          13,
          "hsla(212, 71%, 37%, 0.75)",
          20,
          "hsla(199, 99%, 66%, 0.75)"
        ]
      }
    },
    {
      "id": "Waterway-Drain-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 13,
      "maxzoom": 21,
      "filter": ["==", ["get", "class"], "drain"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          1,
          13,
          0.75,
          18,
          0.5
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          11,
          "hsla(201, 59%, 25%, 0.75)",
          13,
          "hsla(212, 72%, 35%, 0.75)",
          20,
          "hsla(199, 98%, 67%, 0.75)"
        ]
      }
    },
    {
      "id": "Water-Dry-Dock-ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "dock"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.75,
          14,
          1.5,
          18,
          2
        ],
        "line-color": "hsl(0, 0%, 81%)"
      }
    },
    {
      "id": "Water-River-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 13,
      "maxzoom": 21,
      "filter": ["==", ["get", "class"], "river"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1,
          18,
          0.75
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          "hsla(212, 72%, 36%, 0.75)",
          20,
          "hsla(199, 99%, 65%, 0.75)"
        ]
      }
    },
    {
      "id": "Water-River-Ln-Named",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "river"],
        ["has", "name"]
      ],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          1.5,
          13,
          1
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          9,
          "hsla(191, 53%, 28%, 0.01)",
          10,
          "hsla(191, 53%, 37%, 0.75)",
          11,
          "hsla(201, 60%, 25%, 0.75)",
          12,
          "hsla(201, 59%, 27%, 0.75)",
          13,
          "hsla(212, 72%, 40%, 0.75)"
        ]
      }
    },
    {
      "id": "Waterway-WaterRace",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "filter": [
        "all",
        ["==", ["get", "channel_type"], "water_race"],
        ["==", ["get", "class"], "channel"]
      ],
      "layout": {},
      "paint": {
        "line-width": 0.5,
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          "hsla(199, 98%, 59%, 0.3)",
          19,
          "hsl(199, 99%, 55%)"
        ]
      }
    },
    {
      "id": "Landuse-Landfill",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "landfill"],
      "paint": {
        "fill-color": "hsla(33, 43%, 64%, 0.45)",
        "fill-outline-color": "hsl(33, 30%, 40%)"
      }
    },
    {
      "id": "Landuse-Pond",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "class"], "wetland"],
        ["==", ["get", "wetland_feature"], "pond"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(203, 69%, 22%)",
        "fill-outline-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(203, 70%, 27%)",
          13,
          "hsla(201, 60%, 42%, 0.3)",
          19,
          "hsl(201, 55%, 44%)"
        ]
      }
    },
    {
      "id": "Landuse-Reservoir-Covered",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "class"], "reservoir"],
        ["==", ["get", "lid_type"], "covered"]
      ],
      "layout": {},
      "paint": {
        "fill-color": "hsl(0, 1%, 30%)",
        "fill-outline-color": "hsl(0, 1%, 40%)"
      }
    },
    {
      "id": "Landuse-Reservoir-Empty",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 10,
      "filter": [
        "all",
        ["!=", ["get", "lid_type"], "covered"],
        ["==", ["get", "class"], "reservoir"]
      ],
      "paint": {
        "fill-color": "hsl(203, 69%, 28%)",
        "fill-outline-color": "hsl(203, 55%, 38%)"
      }
    },
    {
      "id": "Landuse-Residential",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 8,
      "filter": ["==", ["get", "class"], "residential"],
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          1,
          "hsl(0, 0%, 20%)",
          10,
          "hsla(0, 1%, 21%, 0.95)",
          13,
          "hsla(0, 1%, 23%, 0.6)",
          15,
          "hsla(0, 1%, 9%, 0.4)",
          22,
          "hsla(0, 0%, 6%, 0.1)"
        ],
        "fill-outline-color": "hsla(0, 0%, 22%, 0.01)"
      }
    },
    {
      "id": "Landcover-GolfCourse",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "landcover",
      "filter": [
        "all",
        ["==", ["get", "class"], "grass"],
        ["==", ["get", "grass_type"], "golf_course"]
      ],
      "layout": {},
      "paint": {"fill-color": "hsla(126, 37%, 31%, 0.2)"}
    },
    {
      "id": "Coastline-Ln-2",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "coastline",
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          0.5,
          10,
          0.55,
          15,
          1.25,
          20,
          3.5
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          1,
          "hsla(198, 91%, 75%, 0.5)",
          6,
          "hsla(198, 90%, 59%, 0.5)",
          10,
          "hsla(195, 74%, 57%, 0.5)",
          16,
          "hsla(196, 73%, 41%, 0.5)"
        ]
      }
    },
    {
      "id": "Poi-FishFarm",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "filter": ["==", ["get", "class"], "fish_farm"],
      "layout": {},
      "paint": {"fill-color": "hsl(212, 83%, 26%)"}
    },
    {
      "id": "Poi-SportsField",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "filter": ["==", ["get", "class"], "sports_field"],
      "paint": {"fill-color": "hsla(126, 38%, 26%, 0.2)"}
    },
    {
      "id": "Poi-Storage-Tank-Empty",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "filter": [
        "all",
        ["!", ["has", "store_item"]],
        ["==", ["get", "class"], "storage_tank"]
      ],
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsla(0, 0%, 8%, 0.85)",
          10,
          "hsla(0, 2%, 6%, 0.85)"
        ],
        "fill-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
          14,
          1,
          20,
          0.2
        ],
        "fill-outline-color": "hsl(0, 0%, 78%)"
      }
    },
    {
      "id": "Poi-Siphon",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "siphon"],
      "paint": {
        "fill-color": "hsl(0, 0%, 99%)",
        "fill-outline-color": "hsl(0, 0%, 96%)"
      }
    },
    {
      "id": "Poi-Tank-Pt-Fill-Empty",
      "type": "circle",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "minzoom": 10,
      "filter": [
        "all",
        ["!", ["has", "store_item"]],
        ["==", ["get", "class"], "storage_tank_pt"]
      ],
      "layout": {},
      "paint": {
        "circle-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
          14,
          1,
          20,
          0.2
        ],
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          1.5,
          15,
          3.5
        ],
        "circle-color": "hsl(0, 0%, 0%)",
        "circle-pitch-alignment": "map",
        "circle-stroke-color": "hsl(0, 0%, 100%)"
      }
    },
    {
      "id": "Poi-Dredge-Tailing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "dredge_tailing"],
      "paint": {
        "line-opacity": 0.9,
        "line-width": 10,
        "line-pattern": "dredge_tailing_pnt",
        "line-color": "hsl(0, 1%, 75%)"
      }
    },
    {
      "id": "Poi-Slipway-Symbol-Dash",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "filter": ["==", ["get", "class"], "slipway"],
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          1,
          16,
          4
        ],
        "line-color": "hsl(0, 0%, 76%)"
      }
    },
    {
      "id": "Poi-Slipway-Symbol-Line",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "poi",
      "filter": ["==", ["get", "class"], "slipway"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          4,
          16,
          18
        ],
        "line-color": "hsl(0, 0%, 72%)",
        "line-dasharray": [0.15, 0.4]
      }
    },
    {
      "id": "Parcels-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "parcel_boundaries",
      "minzoom": 15,
      "filter": [
        "!",
        [
          "any",
          [
            "case",
            ["==", ["typeof", ["get", "parcel_intent"]], "string"],
            ["==", ["get", "parcel_intent"], "Hydro"],
            false
          ],
          [
            "case",
            ["==", ["typeof", ["get", "parcel_intent"]], "string"],
            ["==", ["get", "parcel_intent"], "Road"],
            false
          ]
        ]
      ],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          0.2,
          16,
          0.75,
          24,
          1.5
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          "hsl(0, 1%, 17%)",
          16,
          "hsl(0, 2%, 21%)",
          24,
          "hsl(0, 1%, 33%)"
        ]
      }
    },
    {
      "id": "Buildings",
      "type": "fill",
      "source": "LINZ Basemaps",
      "source-layer": "building",
      "minzoom": 16,
      "layout": {},
      "paint": {
        "fill-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          15,
          "hsl(60, 2%, 13%)",
          17,
          "hsl(60, 1%, 15%)",
          18,
          "hsl(60, 3%, 17%)",
          19,
          "hsl(60, 1%, 15%)"
        ]
      }
    },
    {
      "id": "Buildings-Outline",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "building",
      "minzoom": 16,
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          17,
          0.5,
          24,
          1
        ],
        "line-color": "hsla(0, 0%, 30%, 0.6)"
      }
    },
    {
      "id": "Transport-Bridge-Foot",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "brunnel"], "bridge"],
        ["==", ["get", "use_1"], "foot traffic"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          15,
          4,
          19,
          6
        ],
        "line-color": "hsla(0, 1%, 80%, 0.3)"
      }
    },
    {
      "id": "Transport-FootTracks-Shadow",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "track"],
        ["==", ["get", "track_use"], "foot"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1.5,
          15,
          2.5,
          19,
          5
        ],
        "line-color": "hsla(0, 0%, 10%, 0.4)"
      }
    },
    {
      "id": "Transport-VehicleTracks-Shadow",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "track"],
        ["==", ["get", "track_use"], "vehicle"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          2,
          15,
          3,
          19,
          5
        ],
        "line-blur": 0.75,
        "line-dasharray": [8],
        "line-color": "hsla(0, 1%, 8%, 0.4)"
      }
    },
    {
      "id": "Transport-1Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "maxzoom": 18,
      "filter": [
        "all",
        ["!=", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1]
      ],
      "layout": {"line-cap": "round", "line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1.5,
          12,
          3,
          13,
          4.5,
          15,
          5.5,
          18,
          11,
          19,
          40,
          22,
          200
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          "hsla(0, 1%, 69%, 0.1)",
          17,
          "hsla(0, 0%, 70%, 0.1)",
          18,
          "hsla(0, 1%, 71%, 0.1)"
        ]
      }
    },
    {
      "id": "Transport-2Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "maxzoom": 18,
      "filter": [
        "all",
        ["!=", ["get", "class"], "motorway"],
        [
          "match",
          ["get", "lane_count"],
          [2, 3, 4, 5, 6, 7, 8],
          true,
          false
        ]
      ],
      "layout": {"line-cap": "round", "line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          11,
          3.5,
          12,
          3.9,
          13,
          8,
          15,
          10,
          18,
          16,
          19,
          50,
          22,
          200
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          "hsla(0, 0%, 74%, 0.1)",
          17,
          "hsla(0, 1%, 73%, 0.1)",
          18,
          "hsla(0, 0%, 72%, 0.1)"
        ]
      }
    },
    {
      "id": "Transport-1UnMetalled",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "lane_count"], 1],
        ["==", ["get", "surface"], "unmetalled"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          12,
          1,
          13,
          2,
          15,
          3,
          18,
          8,
          19,
          35,
          22,
          180
        ],
        "line-color": "hsl(40, 99%, 3%)"
      }
    },
    {
      "id": "Transport-1Metalled-White",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "lane_count"], 1],
        ["==", ["get", "surface"], "metalled"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          11,
          1,
          13,
          2,
          15,
          3,
          18,
          8,
          19,
          35,
          22,
          180
        ],
        "line-color": "hsl(40, 100%, 2%)"
      }
    },
    {
      "id": "Transport-1-UnderCons",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["!=", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1],
        ["==", ["get", "status"], "under construction"]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          11,
          1,
          13,
          2,
          15,
          3,
          18,
          8,
          19,
          35,
          22,
          180
        ],
        "line-color": "hsla(0, 1%, 72%, 0.1)",
        "line-dasharray": [1, 5]
      }
    },
    {
      "id": "Transport-1Sealed",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["!=", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1],
        ["==", ["get", "surface"], "sealed"]
      ],
      "layout": {"line-cap": "round", "line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          11,
          1,
          13,
          2,
          15,
          3,
          18,
          8,
          19,
          35,
          22,
          180
        ],
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          "hsl(0, 0%, 0%)",
          17,
          "hsl(0, 0%, 0%)",
          19,
          "hsl(0, 0%, 0%)"
        ]
      }
    },
    {
      "id": "Transport-2UnMetalled",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["!=", ["get", "staus"], "under construction"],
        ["==", ["get", "surface"], "unmetalled"],
        [
          "match",
          ["get", "lane_count"],
          [2, 3, 4, 5, 6, 7],
          true,
          false
        ]
      ],
      "layout": {"line-cap": "round", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1.35,
          11,
          1.75,
          13,
          4,
          16,
          7.5,
          18,
          14,
          19,
          55,
          22,
          380
        ],
        "line-color": "hsl(0, 1%, 1%)"
      }
    },
    {
      "id": "Transport-2Metalled-White",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "surface"], "metalled"],
        [
          "match",
          ["get", "lane_count"],
          [2, 3, 4, 5, 6, 7],
          true,
          false
        ]
      ],
      "layout": {"line-cap": "round", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1.35,
          11,
          1.75,
          13,
          4,
          15,
          7.5,
          18,
          14,
          19,
          55,
          22,
          380
        ],
        "line-color": "hsl(0, 1%, 3%)"
      }
    },
    {
      "id": "Transport-2UnderContruction",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["==", ["get", "status"], "under construction"],
        [
          "match",
          ["get", "lane_count"],
          [2, 3, 4, 5, 6, 7],
          true,
          false
        ]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1.35,
          11,
          1.75,
          13,
          4,
          16,
          7.5,
          18,
          14,
          19,
          55,
          22,
          380
        ],
        "line-dasharray": [1, 5],
        "line-color": "hsla(0, 0%, 65%, 0.1)"
      }
    },
    {
      "id": "Transport-2+Sealed",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "all",
        ["!=", ["get", "class"], "motorway"],
        ["==", ["get", "surface"], "sealed"],
        [
          "match",
          ["get", "lane_count"],
          [2, 3, 4, 5, 6, 7],
          true,
          false
        ]
      ],
      "layout": {"line-cap": "round", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1,
          11,
          1,
          12,
          1.75,
          13,
          4,
          15,
          7.5,
          18,
          14,
          19,
          55,
          22,
          380
        ],
        "line-color": "hsl(0, 0%, 0%)"
      }
    },
    {
      "id": "Transport-Railway-Siding",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "class"], "rail"],
        ["has", "rway_use"]
      ],
      "layout": {"line-join": "round", "line-cap": "round"},
      "paint": {"line-color": "hsla(0, 6%, 75%, 0.65)"}
    },
    {
      "id": "Transport-Railway-Single",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["!", ["has", "rway_use"]],
        ["==", ["get", "class"], "rail"],
        ["==", ["get", "track_type"], "single"]
      ],
      "layout": {"line-join": "round", "line-cap": "round"},
      "paint": {"line-width": 2, "line-color": "hsla(0, 4%, 78%, 0.65)"}
    },
    {
      "id": "Transport-Railway-Multiple",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "class"], "rail"],
        ["==", ["get", "track_type"], "multiple"]
      ],
      "layout": {"line-join": "round", "line-cap": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          11,
          2.5,
          19,
          4,
          20,
          4
        ],
        "line-color": "hsla(0, 3%, 73%, 0.65)"
      }
    },
    {
      "id": "Transport-Railway-High",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "maxzoom": 11,
      "filter": ["==", ["get", "class"], "rail"],
      "layout": {"line-join": "round"},
      "paint": {
        "line-width": 2,
        "line-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          "hsl(0, 0%, 35%)",
          10,
          "hsla(0, 1%, 65%, 0.95)"
        ]
      }
    },
    {
      "id": "Transport-Roads-9-Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "maxzoom": 9,
      "filter": ["==", ["get", "class"], "motorway"],
      "layout": {},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          1,
          0,
          6,
          0.5,
          7,
          1,
          8,
          3.5
        ],
        "line-color": "rgba(120, 120, 120, 1)"
      }
    },
    {
      "id": "Transport-Roads-9",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "maxzoom": 9,
      "filter": ["==", ["get", "class"], "motorway"],
      "layout": {"line-cap": "round", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          1,
          0.1,
          5,
          0.4,
          7,
          1.4,
          8,
          2.5
        ],
        "line-color": "hsl(37, 58%, 29%)"
      }
    },
    {
      "id": "Transport-1HWY-Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1]
      ],
      "layout": {"visibility": "none", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.5,
          10,
          1.75,
          12,
          3.25,
          13,
          5,
          15,
          7,
          18,
          13,
          19,
          50,
          22,
          220
        ],
        "line-color": "rgba(120, 120, 120, 1)"
      }
    },
    {
      "id": "Transport-2HWY-Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [2, 3], true, false]
      ],
      "layout": {"visibility": "none", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          3.25,
          10,
          4.5,
          12,
          6.5,
          13,
          8.5,
          15,
          12,
          18,
          19,
          19,
          70,
          22,
          450
        ],
        "line-color": "rgba(120, 120, 120, 0.8)"
      }
    },
    {
      "id": "Transport-HWY-Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "maxzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [4, 5, 6, 7], true, false]
      ],
      "layout": {"visibility": "none", "line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          3.5,
          10,
          5,
          12,
          7.5,
          13,
          9,
          15,
          13,
          18,
          21,
          19,
          80,
          22,
          470
        ],
        "line-color": "rgba(120, 120, 120, 1)"
      }
    },
    {
      "id": "Transport-2HWY-Casing-14",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [2, 3], true, false]
      ],
      "layout": {"line-join": "round", "line-cap": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          3.25,
          10,
          4.5,
          12,
          6.5,
          13,
          8.5,
          15,
          12,
          18,
          19,
          19,
          70,
          22,
          450
        ],
        "line-color": "hsl(0, 0%, 62%)"
      }
    },
    {
      "id": "Transport-1HWY-Casing-14",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1]
      ],
      "layout": {"line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.5,
          10,
          1.75,
          12,
          3.25,
          13,
          5,
          15,
          7,
          18,
          13,
          19,
          50,
          22,
          220
        ],
        "line-color": "hsl(0, 0%, 62%)"
      }
    },
    {
      "id": "Transport-HWY-Casing-14",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [4, 5, 6, 7], true, false]
      ],
      "layout": {"line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          3.5,
          10,
          5,
          12,
          7.5,
          13,
          9,
          15,
          13,
          18,
          21,
          19,
          80,
          22,
          470
        ],
        "line-color": "hsl(0, 0%, 62%)"
      }
    },
    {
      "id": "Transport-2HWY",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [2, 3], true, false]
      ],
      "layout": {"line-join": "round", "line-cap": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.35,
          10,
          1.75,
          11,
          2.25,
          13,
          5.25,
          15,
          8.5,
          18,
          15,
          19,
          60,
          22,
          420
        ],
        "line-color": "hsl(31, 83%, 32%)"
      }
    },
    {
      "id": "Transport-1HWY",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["==", ["get", "lane_count"], 1]
      ],
      "layout": {"line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          0.75,
          10,
          1,
          11,
          1.25,
          13,
          2.5,
          15,
          4,
          18,
          9,
          19,
          40,
          22,
          200
        ],
        "line-color": "hsl(31, 83%, 32%)"
      }
    },
    {
      "id": "Transport-HWY",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "all",
        ["==", ["get", "class"], "motorway"],
        ["match", ["get", "lane_count"], [4, 5, 6, 7], true, false]
      ],
      "layout": {"line-join": "round"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.5,
          10,
          2,
          11,
          3,
          13,
          5.75,
          15,
          9,
          18,
          16.5,
          19,
          70,
          22,
          440
        ],
        "line-color": "hsl(31, 83%, 32%)"
      }
    },
    {
      "id": "Transport-Bridge-VT-Casing",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "brunnel"], "bridge"],
        ["match", ["get", "use_1"], ["train", "vehicle"], true, false]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          6,
          15,
          8,
          18,
          18,
          19,
          75,
          22,
          450
        ],
        "line-color": "hsl(0, 1%, 30%)"
      }
    },
    {
      "id": "Transport-Bridge-VT",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "brunnel"], "bridge"],
        ["match", ["get", "use_1"], ["train", "vehicle"], true, false]
      ],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          5,
          15,
          5,
          18,
          13,
          19,
          66,
          22,
          400
        ],
        "line-color": "hsl(0, 1%, 11%)"
      }
    },
    {
      "id": "Landuse-Boom",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "boom"],
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          1.5,
          13,
          2,
          15,
          4
        ],
        "line-color": "hsl(0, 0%, 65%)"
      }
    },
    {
      "id": "Landuse-Dam",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "filter": ["==", ["get", "class"], "dam_ln"],
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          4,
          15,
          8.5,
          19,
          14.5
        ],
        "line-color": "hsl(0, 0%, 14%)"
      }
    },
    {
      "id": "Landuse-MarineFarm-Ln",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "filter": ["==", ["get", "class"], "marine_farm_ln"],
      "paint": {"line-width": 3, "line-color": "rgba(25, 114, 242, 0.45)"}
    },
    {
      "id": "Transport-Tunnel-VT",
      "type": "line",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": ["==", ["get", "brunnel"], "tunnel"],
      "layout": {"line-join": "bevel"},
      "paint": {
        "line-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.5,
          15,
          1,
          19,
          4
        ],
        "line-gap-width": 8,
        "line-dasharray": [4, 2.5],
        "line-color": "hsla(45, 0%, 79%, 0.6)"
      }
    },
    {
      "id": "Landuse-GravelPit-Label",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 12,
      "filter": ["==", ["get", "class"], "gravel_pit"],
      "layout": {
        "icon-size": 0.8,
        "text-font": ["Open Sans Regular"],
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          6,
          15,
          10
        ]
      },
      "paint": {"text-color": "hsl(0, 0%, 94%)"}
    },
    {
      "id": "Landuse-MarineFarm-Label",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "landuse",
      "minzoom": 15,
      "filter": ["==", ["get", "class"], "marine_farm"],
      "layout": {
        "text-field": ["to-string", ["get", "species"]],
        "text-font": ["Roboto Bold Italic"]
      },
      "paint": {
        "text-halo-width": 1.5,
        "text-color": "hsl(0, 1%, 7%)",
        "text-halo-color": "rgba(25, 114, 242, 0.45)"
      }
    },
    {
      "id": "Waterway-Rapid-Names",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "stream"],
        ["==", ["get", "stream_feature"], "rapid_cl"],
        ["has", "name"]
      ],
      "layout": {
        "symbol-spacing": 750,
        "text-field": ["to-string", ["get", "name"]],
        "text-size": 12,
        "text-anchor": "bottom",
        "symbol-placement": "line",
        "text-font": ["Open Sans Italic"]
      },
      "paint": {
        "text-halo-blur": 1,
        "text-color": "hsl(200, 78%, 76%)",
        "text-halo-color": "hsla(208, 50%, 7%, 0.9)",
        "text-halo-width": 1.5
      }
    },
    {
      "id": "All-Highway-Labels-standard",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "all",
        ["!=", ["get", "lane_count"], 1],
        [
          "match",
          ["get", "hway_num"],
          [
            "1,3",
            "12,15",
            "14,15",
            "2,50",
            "20A",
            "20B",
            "25A",
            "29A",
            "30A",
            "6,94",
            "6,96",
            "67A",
            "74A"
          ],
          false,
          true
        ],
        ["has", "hway_num"]
      ],
      "layout": {
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          9,
          11,
          10,
          15,
          14
        ],
        "icon-pitch-alignment": "viewport",
        "icon-offset": [0, 1],
        "icon-image": "highway_pnt_standard",
        "icon-rotation-alignment": "viewport",
        "icon-text-fit-padding": [1, 4, 3, 3],
        "symbol-spacing": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          500,
          13,
          400
        ],
        "text-font": ["Open Sans Bold"],
        "symbol-placement": "line",
        "text-rotation-alignment": "viewport",
        "icon-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.2,
          12,
          1.5,
          15,
          1.7
        ],
        "text-pitch-alignment": "viewport",
        "text-field": ["to-string", ["get", "hway_num"]]
      },
      "paint": {
        "text-color": "rgb(0,0,0)",
        "icon-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          0.9,
          14,
          1
        ]
      }
    },
    {
      "id": "All-Highway-Labels-three",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "match",
        ["get", "hway_num"],
        ["20A", "20B", "25A", "29A", "30A", "67A", "74A"],
        true,
        false
      ],
      "layout": {
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          9,
          11,
          10,
          15,
          14
        ],
        "icon-pitch-alignment": "viewport",
        "icon-offset": [0, 1],
        "icon-image": "highway_pnt_wide",
        "icon-rotation-alignment": "viewport",
        "icon-text-fit-padding": [1, 4, 3, 3],
        "symbol-spacing": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          500,
          13,
          400
        ],
        "text-font": ["Open Sans Bold"],
        "symbol-placement": "line",
        "text-rotation-alignment": "viewport",
        "icon-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          8,
          1.2,
          12,
          1.5,
          15,
          1.7
        ],
        "text-pitch-alignment": "viewport",
        "text-field": ["to-string", ["get", "hway_num"]]
      },
      "paint": {
        "text-color": "rgb(0,0,0)",
        "icon-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          0.9,
          14,
          1
        ]
      }
    },
    {
      "id": "All-Road-Labels",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": ["has", "name"],
      "layout": {
        "text-field": ["to-string", ["get", "name"]],
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          8,
          15,
          8,
          18,
          10,
          19,
          10,
          22,
          60
        ],
        "icon-text-fit": "both",
        "symbol-placement": "line",
        "text-font": ["Open Sans Regular"]
      },
      "paint": {
        "text-halo-color": "hsla(0, 0%, 7%, 0.9)",
        "text-color": "hsl(0, 0%, 88%)",
        "text-halo-width": 2.5,
        "text-opacity": 1
      }
    },
    {
      "id": "Transport-Tunnel-Label",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "transportation",
      "minzoom": 15,
      "filter": ["==", ["get", "brunnel"], "tunnel"],
      "layout": {
        "symbol-spacing": 180,
        "text-field": ["to-string", ["get", "brunnel"]],
        "text-offset": [
          "interpolate",
          ["linear"],
          ["zoom"],
          15,
          ["literal", [0, -1.25]],
          17,
          ["literal", [0, -1.75]],
          19,
          ["literal", [0, -6]],
          20,
          ["literal", [0, -9]],
          22,
          ["literal", [0, -16]]
        ],
        "text-size": 10,
        "symbol-placement": "line",
        "text-font": ["Roboto Black"]
      },
      "paint": {
        "text-halo-width": 2,
        "text-color": "hsl(0, 0%, 85%)",
        "text-halo-color": "hsla(0, 0%, 7%, 0.85)"
      }
    },
    {
      "id": "Airport-Label",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "aerodrome_label",
      "minzoom": 12,
      "layout": {
        "text-size": 10,
        "icon-pitch-alignment": "viewport",
        "icon-offset": [0, 0],
        "icon-image": "airport_airport_pnt_fill",
        "icon-rotation-alignment": "viewport",
        "icon-anchor": "bottom",
        "text-font": ["Open Sans Bold Italic"],
        "icon-size": 1.2,
        "text-anchor": "top",
        "text-field": ["to-string", ["get", "name"]],
        "text-max-width": 5
      },
      "paint": {
        "text-halo-blur": 0.5,
        "text-color": "hsl(0, 0%, 88%)",
        "text-halo-color": "hsla(0, 0%, 7%, 0.9)",
        "text-halo-width": 1,
        "icon-opacity": 0.8
      }
    },
    {
      "id": "Aeroway-Airstrip-Label",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "aeroway",
      "minzoom": 15,
      "filter": [
        "all",
        ["!", ["has", "surface"]],
        ["==", ["get", "class"], "runway"]
      ],
      "layout": {
        "text-justify": "left",
        "text-field": "airstrip",
        "text-font": ["Roboto Light"],
        "text-size": 10,
        "text-anchor": "left"
      },
      "paint": {
        "text-halo-width": 1.5,
        "text-halo-blur": 0.5,
        "text-halo-color": "hsla(0, 0%, 7%, 0.9)",
        "text-color": "hsl(0, 0%, 85%)"
      }
    },
    {
      "id": "All-Reef-Names",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 13,
      "filter": [
        "all",
        ["==", ["get", "class"], "reef"],
        ["has", "name"]
      ],
      "layout": {
        "text-max-width": 4,
        "text-field": ["to-string", ["get", "name"]],
        "text-offset": [0, 1],
        "text-size": 12,
        "text-font": ["Open Sans Italic"]
      },
      "paint": {
        "text-halo-width": 2,
        "text-color": "hsl(200, 78%, 76%)",
        "text-halo-color": "hsla(208, 50%, 7%, 0.9)"
      }
    },
    {
      "id": "All-Lake-Names",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 11,
      "filter": [
        "all",
        ["==", ["get", "class"], "lake"],
        ["has", "name"]
      ],
      "layout": {
        "text-max-width": 4,
        "text-field": ["to-string", ["get", "name"]],
        "text-font": ["Open Sans Italic"],
        "text-size": 12
      },
      "paint": {
        "text-halo-width": 2,
        "text-color": "hsl(200, 78%, 76%)",
        "text-halo-color": "hsla(208, 50%, 7%, 0.9)"
      }
    },
    {
      "id": "All-River-Names",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "water",
      "minzoom": 12,
      "filter": [
        "all",
        ["==", ["get", "class"], "river"],
        ["has", "name"]
      ],
      "layout": {
        "text-field": ["to-string", ["get", "name"]],
        "text-size": 12,
        "text-anchor": "bottom",
        "text-allow-overlap": true,
        "symbol-placement": "line",
        "text-font": ["Open Sans Italic"],
        "symbol-spacing": 1000,
        "text-ignore-placement": true
      },
      "paint": {
        "text-halo-blur": 1,
        "text-color": "hsl(200, 78%, 76%)",
        "text-halo-color": "hsla(208, 50%, 7%, 0.9)",
        "text-halo-width": 1.5
      }
    },
    {
      "id": "All-Waterway-River-Names",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "waterway",
      "minzoom": 12,
      "filter": [
        "all",
        ["==", ["get", "class"], "river"],
        ["has", "name"]
      ],
      "layout": {
        "symbol-spacing": 1000,
        "text-field": ["to-string", ["get", "name"]],
        "text-size": 12,
        "text-anchor": "bottom",
        "text-ignore-placement": true,
        "text-allow-overlap": true,
        "symbol-placement": "line",
        "text-font": ["Open Sans Italic"]
      },
      "paint": {
        "text-halo-blur": 1,
        "text-color": "hsl(200, 78%, 76%)",
        "text-halo-color": "hsla(208, 50%, 7%, 0.9)",
        "text-halo-width": 1.5
      }
    },
    {
      "id": "Housenumber",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "housenumber",
      "minzoom": 17,
      "layout": {
        "text-field": ["to-string", ["get", "housenumber"]],
        "text-font": ["Open Sans Regular"],
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          17,
          9,
          19,
          10
        ],
        "text-anchor": "bottom"
      },
      "paint": {
        "icon-color": "rgba(255,0,0,0.6)",
        "text-halo-blur": 20,
        "text-color": "hsl(0, 0%, 78%)",
        "text-halo-color": "hsla(0, 0%, 7%, 0.8)",
        "text-halo-width": 2
      }
    },
    {
      "id": "Place-Names-13",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "place",
      "minzoom": 13,
      "layout": {
        "text-optional": true,
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          2,
          10,
          5,
          16,
          8,
          16,
          10,
          17,
          12,
          16,
          14,
          16
        ],
        "text-allow-overlap": true,
        "icon-text-fit": "both",
        "text-variable-anchor": ["top", "bottom-left"],
        "text-font": ["Roboto Regular"],
        "text-offset": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          ["literal", [0, 1.75]],
          6,
          ["literal", [0, 1.25]]
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-field": ["to-string", ["get", "name"]],
        "text-letter-spacing": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.08,
          13,
          0.04,
          14,
          0
        ],
        "text-max-width": 7
      },
      "paint": {
        "text-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(0, 0%, 87%)",
          19,
          "hsl(0, 0%, 69%)"
        ],
        "icon-halo-blur": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1,
          14,
          0.5
        ],
        "icon-halo-color": "rgba(255, 255, 255, 1)",
        "icon-halo-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1,
          14,
          2
        ],
        "icon-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "rgba(53, 53, 53, 1)",
          10,
          "rgba(53, 53, 53, 1)"
        ],
        "text-halo-color": "hsla(0, 0%, 7%, 0.9)",
        "text-translate-anchor": "viewport",
        "text-halo-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          1.5,
          9,
          2
        ],
        "text-halo-blur": 1
      }
    },
    {
      "id": "Place-Names-3-12",
      "type": "symbol",
      "source": "LINZ Basemaps",
      "source-layer": "place",
      "minzoom": 3,
      "maxzoom": 13,
      "layout": {
        "text-optional": true,
        "text-size": [
          "interpolate",
          ["linear"],
          ["zoom"],
          2,
          10,
          5,
          16,
          8,
          16,
          10,
          17,
          12,
          17,
          14,
          17
        ],
        "text-variable-anchor": ["top", "bottom-left"],
        "text-font": ["Roboto Regular"],
        "text-offset": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          ["literal", [0, 1.75]],
          6,
          ["literal", [0, 1.25]]
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-field": ["to-string", ["get", "name"]],
        "text-letter-spacing": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          0.08,
          13,
          0.04,
          14,
          0
        ],
        "text-max-width": 6
      },
      "paint": {
        "text-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "hsl(0, 0%, 81%)",
          19,
          "hsl(0, 0%, 62%)"
        ],
        "icon-halo-blur": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1,
          14,
          0.5
        ],
        "icon-halo-color": "rgba(255, 255, 255, 1)",
        "icon-translate-anchor": "viewport",
        "icon-halo-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          13,
          1,
          14,
          2
        ],
        "icon-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          6,
          "rgba(53, 53, 53, 1)",
          10,
          "rgba(53, 53, 53, 1)"
        ],
        "text-halo-color": "hsla(0, 0%, 7%, 0.9)",
        "text-halo-width": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          1.5,
          9,
          2
        ],
        "text-halo-blur": 1
      }
    }
  ],
  "metadata": {
    "maputnik:renderer": "mbgljs"
  },
  "glyphs": "https://basemaps.linz.govt.nz/v1/fonts/{fontstack}/{range}.pbf",
  "sprite": "https://basemaps.linz.govt.nz/v1/sprites/topographic"
})